export default "__VITE_ASSET__392ba868__"